import React, { forwardRef, } from "react";
import { IconButton as ChakraIconButton, Icon } from "@chakra-ui/react";
export const IconButton = forwardRef(({ icon, ...props }, ref) => {
    return (React.createElement(ChakraIconButton, { ref: ref, icon: React.createElement(Icon, { as: icon, boxSize: 4 }), variant: "ghost", ...props }));
});
